import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
// SERVICES
import { confirmPassword } from "../../../services/auth";
import { updateStripeDetails } from "../../../services/payments";
import { useTranslation } from "react-i18next";
import {
  PasswordStep,
  SecretField,
  SuccessStep,
  secureModalProps,
} from "./SecureModalParts";

const EditModal = ({ show, setShow, updateData, stripeDetails }) => {
  const [form2, setForm2] = useState(false);
  const [form3, setForm3] = useState(false);
  const { t } = useTranslation();

  // console.log("edit", stripeDetails);

  const handleClose = () => {
    setShow(false);
    setForm2(false);
    setForm3(false);
    setStripePublicKey("");
    setStripeSecretKey("");
  };
  const handleDone = () => {
    setShow(false);
    setForm2(false);
    setForm3(false);
    setStripePublicKey("");
    setStripeSecretKey("");
  };
  const getSessionData = () => {
    const userDetails_Session = JSON.parse(localStorage.getItem("session"));
    return {
      _id: userDetails_Session._id,

      email: userDetails_Session.email,
    };
  };
  const [userDetails] = useState(getSessionData());
  const [confirmPass, setConfirmPass] = useState("");
  const [wrongPass, setWrongPass] = useState(false);

  const dataObj = {
    email: userDetails.email,
    password: confirmPass,
  };
  const verifyPass = async () => {
    try {
      // console.log(dataObj);
      const result = await confirmPassword(dataObj);
      // console.log(result);
      if (result) {
        setForm2(true);
        setWrongPass(false);
        setConfirmPass(""); // Clear the password field
        setStripePublicKey(stripeDetails.public_key);
        setStripeSecretKey(stripeDetails.secret_key);
      }
    } catch (error) {
      setWrongPass(true);
      setTimeout(() => {
        setWrongPass(false);
      }, 3000);
    }
  };
  const [stripePublicKey, setStripePublicKey] = useState("");
  const [stripeSecretkKey, setStripeSecretKey] = useState("");

  useEffect(() => {
    setStripePublicKey(stripeDetails.public_key);
    setStripeSecretKey(stripeDetails.secret_key);
    // Keys of the details known when the modal is created.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [generalInfo, setGeneralInfo] = useState({});
  useEffect(() => {
    setGeneralInfo({
      public_key: stripePublicKey,
      secret_key: stripeSecretkKey,
    });
  }, [stripePublicKey, stripeSecretkKey]);
  // console.log(generalInfo);
  const editDetails = async () => {
    let isAllKeysFilled = true;

    for (const key in generalInfo) {
      if (
        generalInfo[key] === null ||
        generalInfo[key] === undefined ||
        generalInfo[key] === "default" ||
        generalInfo[key] === ""
      ) {
        isAllKeysFilled = false;
        return; // Exit the function when condition is not met
      }
    }
    if (isAllKeysFilled) {
      try {
        const data = await updateStripeDetails(generalInfo, stripeDetails._id);
        updateData(data);
        setForm3(true);
        setStripePublicKey("");
        setStripeSecretKey("");
      } catch (error) {
        // Handle the error if the updateStripeDetails call fails
        console.log(error);
      }
    } else {
      toast.error(t("Please Enter Both Keys!"), {
        progressStyle: { background: "var(--iq-primary)" },
      });
    }
  };
  const disconnectStripe = async () => {
    try {
      const data = await updateStripeDetails(
        {
          public_key: "",
          secret_key: "",
        },
        stripeDetails._id
      );
      updateData(data);
      setForm3(true);
      setStripePublicKey("");
      setStripePublicKey("");
    } catch (error) {
      // Handle the error if the updateStripeDetails call fails
      console.log(error);
    }
    // update api with empty keys then get api then send the data from get api to prop
    setForm3(true);
  };
  return (
    <Modal show={show} onHide={handleClose} {...secureModalProps}>
      {!form2 ? (
        <PasswordStep
          title={t("Stripe")}
          email={userDetails?.email}
          password={confirmPass}
          onPasswordChange={setConfirmPass}
          wrongPassword={wrongPass}
          onCancel={handleClose}
          onContinue={verifyPass}
        />
      ) : !form3 ? (
        <>
          <Modal.Header>
            <Modal.Title>{t("Edit Stripe")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ui-form secure-form">
              <p className="secure-intro">
                {t("Please enter stripe public and secret key")}
              </p>
              <SecretField
                id="stripe-public-key"
                label={t("Stripe Public Key")}
                value={stripePublicKey}
                onChange={setStripePublicKey}
              />
              <SecretField
                id="stripe-secret-key"
                label={t("Stripe Secret Key")}
                value={stripeSecretkKey}
                onChange={setStripeSecretKey}
              />
              <div className="secure-danger">
                <div>
                  <strong>{t("Disconnect")}</strong>
                  <span>
                    {t("Payments by card will no longer be possible.")}
                  </span>
                </div>
                <button
                  type="button"
                  className="ui-btn ui-btn-danger"
                  onClick={disconnectStripe}
                >
                  {t("Disconnect")}
                </button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="ui-btn ui-btn-secondary"
              onClick={handleClose}
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="ui-btn"
              disabled={!stripePublicKey || !stripeSecretkKey}
              onClick={editDetails}
            >
              {t("Save")}
            </button>
          </Modal.Footer>
        </>
      ) : (
        <SuccessStep
          message={
            stripeDetails.public_key === "" || stripeDetails.secret_key === ""
              ? t("Stripe Disconnected Successfully!")
              : t("Stripe Keys Updated Successfully!")
          }
          onDone={handleDone}
        />
      )}
    </Modal>
  );
};

export default EditModal;
